module.exports = __webpack_public_path__ + "img/partner.d660922b.png";